
/**
 * @license 
 * Copyright Google Inc. All Rights Reserved.
 * 
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const win = typeof window !== 'undefined' && window || <any>{};
export {win as window};



// WEBPACK FOOTER //
// ../../../../packages/platform-browser/src/browser/tools/browser.ts